import { z } from 'zod';

export const EmailSchema = z.string().email();
export const PasswordSchema = z.string().min(8).max(20);
export const NameSchema = z.string().trim().min(2).max(50);
export const CodeSchema = z.string().length(6);
export const IdSchema = z.string().uuid();

export interface CommonValidationReturnType {
  isValid: boolean;
  errorMessage?: string;
}
